/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListEventNamesResponse
 */
export interface ListEventNamesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListEventNamesResponse
     */
    data: Array<ListEventNamesResponseDataEnum>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEventNamesResponse
     */
    pagination: Pagination;
}

/**
* @export
* @enum {string}
*/
export enum ListEventNamesResponseDataEnum {
    AbsenceCreated = 'Absence_Created',
    AbsenceDeleted = 'Absence_Deleted',
    AbsenceUpdated = 'Absence_Updated',
    AbsenceCategoryCreated = 'AbsenceCategory_Created',
    AbsenceCategoryDeleted = 'AbsenceCategory_Deleted',
    AbsenceCategoryUpdated = 'AbsenceCategory_Updated',
    AccessRoleCreated = 'AccessRole_Created',
    AccessRoleDeleted = 'AccessRole_Deleted',
    AccessRoleUpdated = 'AccessRole_Updated',
    AccessRolesPermissionCreated = 'AccessRolesPermission_Created',
    AccessRolesPermissionDeleted = 'AccessRolesPermission_Deleted',
    AccessRolesPermissionUpdated = 'AccessRolesPermission_Updated',
    AddressCreated = 'Address_Created',
    AddressDeleted = 'Address_Deleted',
    AddressUpdated = 'Address_Updated',
    BatchJobLogCreated = 'BatchJobLog_Created',
    BatchJobLogDeleted = 'BatchJobLog_Deleted',
    BatchJobLogUpdated = 'BatchJobLog_Updated',
    BatchJobMessageReceived = 'BatchJobMessage_Received',
    BillingCancellationCreated = 'BillingCancellation_Created',
    BillingCancellationDeleted = 'BillingCancellation_Deleted',
    BillingCancellationUpdated = 'BillingCancellation_Updated',
    BillingCouponRedemptionCreated = 'BillingCouponRedemption_Created',
    BillingCouponRedemptionDeleted = 'BillingCouponRedemption_Deleted',
    BillingCouponRedemptionUpdated = 'BillingCouponRedemption_Updated',
    BillingCreditCreated = 'BillingCredit_Created',
    BillingCreditDeleted = 'BillingCredit_Deleted',
    BillingCreditUpdated = 'BillingCredit_Updated',
    BillingCreditDeltaCreated = 'BillingCreditDelta_Created',
    BillingCreditDeltaDeleted = 'BillingCreditDelta_Deleted',
    BillingCreditDeltaUpdated = 'BillingCreditDelta_Updated',
    BillingDetailCreated = 'BillingDetail_Created',
    BillingDetailDeleted = 'BillingDetail_Deleted',
    BillingDetailUpdated = 'BillingDetail_Updated',
    BillingInvoiceCreated = 'BillingInvoice_Created',
    BillingInvoiceDeleted = 'BillingInvoice_Deleted',
    BillingInvoiceUpdated = 'BillingInvoice_Updated',
    BillingInvoiceLineCreated = 'BillingInvoiceLine_Created',
    BillingInvoiceLineDeleted = 'BillingInvoiceLine_Deleted',
    BillingInvoiceLineUpdated = 'BillingInvoiceLine_Updated',
    BillingPackageCreated = 'BillingPackage_Created',
    BillingPackageDeleted = 'BillingPackage_Deleted',
    BillingPackageUpdated = 'BillingPackage_Updated',
    BillingPackageQuotaOverrideCreated = 'BillingPackageQuotaOverride_Created',
    BillingPackageQuotaOverrideDeleted = 'BillingPackageQuotaOverride_Deleted',
    BillingPackageQuotaOverrideUpdated = 'BillingPackageQuotaOverride_Updated',
    BillingPackagesBillingProductPriceCreated = 'BillingPackagesBillingProductPrice_Created',
    BillingPackagesBillingProductPriceDeleted = 'BillingPackagesBillingProductPrice_Deleted',
    BillingPackagesBillingProductPriceUpdated = 'BillingPackagesBillingProductPrice_Updated',
    BillingPaymentCreated = 'BillingPayment_Created',
    BillingPaymentDeleted = 'BillingPayment_Deleted',
    BillingPaymentUpdated = 'BillingPayment_Updated',
    BillingPaymentMethodCreated = 'BillingPaymentMethod_Created',
    BillingPaymentMethodDeleted = 'BillingPaymentMethod_Deleted',
    BillingPaymentMethodUpdated = 'BillingPaymentMethod_Updated',
    BillingProductCreated = 'BillingProduct_Created',
    BillingProductDeleted = 'BillingProduct_Deleted',
    BillingProductUpdated = 'BillingProduct_Updated',
    BillingProductPriceCreated = 'BillingProductPrice_Created',
    BillingProductPriceDeleted = 'BillingProductPrice_Deleted',
    BillingProductPriceUpdated = 'BillingProductPrice_Updated',
    BillingQuotaDefinitionCreated = 'BillingQuotaDefinition_Created',
    BillingQuotaDefinitionDeleted = 'BillingQuotaDefinition_Deleted',
    BillingQuotaDefinitionUpdated = 'BillingQuotaDefinition_Updated',
    BillingQuotaOverrideCreated = 'BillingQuotaOverride_Created',
    BillingQuotaOverrideDeleted = 'BillingQuotaOverride_Deleted',
    BillingQuotaOverrideUpdated = 'BillingQuotaOverride_Updated',
    BillingSubscriptionCreated = 'BillingSubscription_Created',
    BillingSubscriptionDeleted = 'BillingSubscription_Deleted',
    BillingSubscriptionUpdated = 'BillingSubscription_Updated',
    BillingSubscriptionsBillingProductPriceCreated = 'BillingSubscriptionsBillingProductPrice_Created',
    BillingSubscriptionsBillingProductPriceDeleted = 'BillingSubscriptionsBillingProductPrice_Deleted',
    BillingSubscriptionsBillingProductPriceUpdated = 'BillingSubscriptionsBillingProductPrice_Updated',
    BillingWalletCreated = 'BillingWallet_Created',
    BillingWalletDeleted = 'BillingWallet_Deleted',
    BillingWalletUpdated = 'BillingWallet_Updated',
    BillingWalletTypeCreated = 'BillingWalletType_Created',
    BillingWalletTypeDeleted = 'BillingWalletType_Deleted',
    BillingWalletTypeUpdated = 'BillingWalletType_Updated',
    BudgetSummaryCreated = 'BudgetSummary_Created',
    BudgetSummaryDeleted = 'BudgetSummary_Deleted',
    BudgetSummaryUpdated = 'BudgetSummary_Updated',
    ClockInPortalCreated = 'ClockInPortal_Created',
    ClockInPortalDeleted = 'ClockInPortal_Deleted',
    ClockInPortalUpdated = 'ClockInPortal_Updated',
    ClockInPortalsLocationCreated = 'ClockInPortalsLocation_Created',
    ClockInPortalsLocationDeleted = 'ClockInPortalsLocation_Deleted',
    ClockInPortalsLocationUpdated = 'ClockInPortalsLocation_Updated',
    ClockingEventCreated = 'ClockingEvent_Created',
    ClockingEventDeleted = 'ClockingEvent_Deleted',
    ClockingEventUpdated = 'ClockingEvent_Updated',
    ClockingSettingCreated = 'ClockingSetting_Created',
    ClockingSettingDeleted = 'ClockingSetting_Deleted',
    ClockingSettingUpdated = 'ClockingSetting_Updated',
    CompaniesFeatureFlagCreated = 'CompaniesFeatureFlag_Created',
    CompaniesFeatureFlagDeleted = 'CompaniesFeatureFlag_Deleted',
    CompaniesFeatureFlagUpdated = 'CompaniesFeatureFlag_Updated',
    CompaniesFeatureGroupCreated = 'CompaniesFeatureGroup_Created',
    CompaniesFeatureGroupDeleted = 'CompaniesFeatureGroup_Deleted',
    CompaniesFeatureGroupUpdated = 'CompaniesFeatureGroup_Updated',
    CompanyCreated = 'Company_Created',
    CompanyDeleted = 'Company_Deleted',
    CompanyUpdated = 'Company_Updated',
    CompanyNotificationChannelCreated = 'CompanyNotificationChannel_Created',
    CompanyNotificationChannelDeleted = 'CompanyNotificationChannel_Deleted',
    CompanyNotificationChannelUpdated = 'CompanyNotificationChannel_Updated',
    CompanyOnboardingCreated = 'CompanyOnboarding_Created',
    CompanyOnboardingDeleted = 'CompanyOnboarding_Deleted',
    CompanyOnboardingUpdated = 'CompanyOnboarding_Updated',
    CompanySettingCreated = 'CompanySetting_Created',
    CompanySettingDeleted = 'CompanySetting_Deleted',
    CompanySettingUpdated = 'CompanySetting_Updated',
    DaySummaryCreated = 'DaySummary_Created',
    DaySummaryDeleted = 'DaySummary_Deleted',
    DaySummaryUpdated = 'DaySummary_Updated',
    DigiticketsConnectionCreated = 'DigiticketsConnection_Created',
    DigiticketsConnectionDeleted = 'DigiticketsConnection_Deleted',
    DigiticketsConnectionUpdated = 'DigiticketsConnection_Updated',
    DigiticketsScheduleMapCreated = 'DigiticketsScheduleMap_Created',
    DigiticketsScheduleMapDeleted = 'DigiticketsScheduleMap_Deleted',
    DigiticketsScheduleMapUpdated = 'DigiticketsScheduleMap_Updated',
    DocumentCreated = 'Document_Created',
    DocumentDeleted = 'Document_Deleted',
    DocumentUpdated = 'Document_Updated',
    DocumentAcceptanceCreated = 'DocumentAcceptance_Created',
    DocumentAcceptanceDeleted = 'DocumentAcceptance_Deleted',
    DocumentAcceptanceUpdated = 'DocumentAcceptance_Updated',
    DocumentReadCreated = 'DocumentRead_Created',
    DocumentReadDeleted = 'DocumentRead_Deleted',
    DocumentReadUpdated = 'DocumentRead_Updated',
    DocumentVersionCreated = 'DocumentVersion_Created',
    DocumentVersionDeleted = 'DocumentVersion_Deleted',
    DocumentVersionUpdated = 'DocumentVersion_Updated',
    DocumentVersionsEmployeeCreated = 'DocumentVersionsEmployee_Created',
    DocumentVersionsEmployeeDeleted = 'DocumentVersionsEmployee_Deleted',
    DocumentVersionsEmployeeUpdated = 'DocumentVersionsEmployee_Updated',
    DocumentsEmployeeCreated = 'DocumentsEmployee_Created',
    DocumentsEmployeeDeleted = 'DocumentsEmployee_Deleted',
    DocumentsEmployeeUpdated = 'DocumentsEmployee_Updated',
    DocumentsJobRoleCreated = 'DocumentsJobRole_Created',
    DocumentsJobRoleDeleted = 'DocumentsJobRole_Deleted',
    DocumentsJobRoleUpdated = 'DocumentsJobRole_Updated',
    EmergencyContactCreated = 'EmergencyContact_Created',
    EmergencyContactDeleted = 'EmergencyContact_Deleted',
    EmergencyContactUpdated = 'EmergencyContact_Updated',
    EmployeeCreated = 'Employee_Created',
    EmployeeDeleted = 'Employee_Deleted',
    EmployeeUpdated = 'Employee_Updated',
    EmployeeAbsenceSummaryCreated = 'EmployeeAbsenceSummary_Created',
    EmployeeAbsenceSummaryDeleted = 'EmployeeAbsenceSummary_Deleted',
    EmployeeAbsenceSummaryUpdated = 'EmployeeAbsenceSummary_Updated',
    EmployeeAttributeCreated = 'EmployeeAttribute_Created',
    EmployeeAttributeDeleted = 'EmployeeAttribute_Deleted',
    EmployeeAttributeUpdated = 'EmployeeAttribute_Updated',
    EmployeeClockingProfileCreated = 'EmployeeClockingProfile_Created',
    EmployeeClockingProfileDeleted = 'EmployeeClockingProfile_Deleted',
    EmployeeClockingProfileUpdated = 'EmployeeClockingProfile_Updated',
    EmployeeGroupCreated = 'EmployeeGroup_Created',
    EmployeeGroupDeleted = 'EmployeeGroup_Deleted',
    EmployeeGroupUpdated = 'EmployeeGroup_Updated',
    EmployeeInviteCreated = 'EmployeeInvite_Created',
    EmployeeInviteDeleted = 'EmployeeInvite_Deleted',
    EmployeeInviteUpdated = 'EmployeeInvite_Updated',
    EmployeeLeaveBalancesSummaryCreated = 'EmployeeLeaveBalancesSummary_Created',
    EmployeeLeaveBalancesSummaryDeleted = 'EmployeeLeaveBalancesSummary_Deleted',
    EmployeeLeaveBalancesSummaryUpdated = 'EmployeeLeaveBalancesSummary_Updated',
    EmployeeLeaveSummaryCreated = 'EmployeeLeaveSummary_Created',
    EmployeeLeaveSummaryDeleted = 'EmployeeLeaveSummary_Deleted',
    EmployeeLeaveSummaryUpdated = 'EmployeeLeaveSummary_Updated',
    EmployeeLeaveTypeBalanceCreated = 'EmployeeLeaveTypeBalance_Created',
    EmployeeLeaveTypeBalanceDeleted = 'EmployeeLeaveTypeBalance_Deleted',
    EmployeeLeaveTypeBalanceUpdated = 'EmployeeLeaveTypeBalance_Updated',
    EmployeeMessageCreated = 'EmployeeMessage_Created',
    EmployeeMessageDeleted = 'EmployeeMessage_Deleted',
    EmployeeMessageUpdated = 'EmployeeMessage_Updated',
    EmployeeMessageRecipientCreated = 'EmployeeMessageRecipient_Created',
    EmployeeMessageRecipientDeleted = 'EmployeeMessageRecipient_Deleted',
    EmployeeMessageRecipientUpdated = 'EmployeeMessageRecipient_Updated',
    EmployeeNotificationChannelCreated = 'EmployeeNotificationChannel_Created',
    EmployeeNotificationChannelDeleted = 'EmployeeNotificationChannel_Deleted',
    EmployeeNotificationChannelUpdated = 'EmployeeNotificationChannel_Updated',
    EmployeeOnboardingCreated = 'EmployeeOnboarding_Created',
    EmployeeOnboardingDeleted = 'EmployeeOnboarding_Deleted',
    EmployeeOnboardingUpdated = 'EmployeeOnboarding_Updated',
    EmployeePayDetailCreated = 'EmployeePayDetail_Created',
    EmployeePayDetailDeleted = 'EmployeePayDetail_Deleted',
    EmployeePayDetailUpdated = 'EmployeePayDetail_Updated',
    EmployeePersonalDetailCreated = 'EmployeePersonalDetail_Created',
    EmployeePersonalDetailDeleted = 'EmployeePersonalDetail_Deleted',
    EmployeePersonalDetailUpdated = 'EmployeePersonalDetail_Updated',
    EmployeesAccessRoleCreated = 'EmployeesAccessRole_Created',
    EmployeesAccessRoleDeleted = 'EmployeesAccessRole_Deleted',
    EmployeesAccessRoleUpdated = 'EmployeesAccessRole_Updated',
    EmployeesAccessRolesPermissionCreated = 'EmployeesAccessRolesPermission_Created',
    EmployeesAccessRolesPermissionDeleted = 'EmployeesAccessRolesPermission_Deleted',
    EmployeesAccessRolesPermissionUpdated = 'EmployeesAccessRolesPermission_Updated',
    EmployeesAccessRolesPermissionsTargetCreated = 'EmployeesAccessRolesPermissionsTarget_Created',
    EmployeesAccessRolesPermissionsTargetDeleted = 'EmployeesAccessRolesPermissionsTarget_Deleted',
    EmployeesAccessRolesPermissionsTargetUpdated = 'EmployeesAccessRolesPermissionsTarget_Updated',
    EmployeesEmployeeAttributeCreated = 'EmployeesEmployeeAttribute_Created',
    EmployeesEmployeeAttributeDeleted = 'EmployeesEmployeeAttribute_Deleted',
    EmployeesEmployeeAttributeUpdated = 'EmployeesEmployeeAttribute_Updated',
    EmployeesJobRoleCreated = 'EmployeesJobRole_Created',
    EmployeesJobRoleDeleted = 'EmployeesJobRole_Deleted',
    EmployeesJobRoleUpdated = 'EmployeesJobRole_Updated',
    EmployeesLocationCreated = 'EmployeesLocation_Created',
    EmployeesLocationDeleted = 'EmployeesLocation_Deleted',
    EmployeesLocationUpdated = 'EmployeesLocation_Updated',
    EmployeesScheduleCreated = 'EmployeesSchedule_Created',
    EmployeesScheduleDeleted = 'EmployeesSchedule_Deleted',
    EmployeesScheduleUpdated = 'EmployeesSchedule_Updated',
    FeaturesEnabledCreated = 'FeaturesEnabled_Created',
    FeaturesEnabledDeleted = 'FeaturesEnabled_Deleted',
    FeaturesEnabledUpdated = 'FeaturesEnabled_Updated',
    HistoryCreated = 'History_Created',
    HistoryDeleted = 'History_Deleted',
    HistoryUpdated = 'History_Updated',
    HolidayRegionCreated = 'HolidayRegion_Created',
    HolidayRegionDeleted = 'HolidayRegion_Deleted',
    HolidayRegionUpdated = 'HolidayRegion_Updated',
    IcalFeedCreated = 'IcalFeed_Created',
    IcalFeedDeleted = 'IcalFeed_Deleted',
    IcalFeedUpdated = 'IcalFeed_Updated',
    IcrTouchConnectionCreated = 'IcrTouchConnection_Created',
    IcrTouchConnectionDeleted = 'IcrTouchConnection_Deleted',
    IcrTouchConnectionUpdated = 'IcrTouchConnection_Updated',
    IcrTouchScheduleConfigCreated = 'IcrTouchScheduleConfig_Created',
    IcrTouchScheduleConfigDeleted = 'IcrTouchScheduleConfig_Deleted',
    IcrTouchScheduleConfigUpdated = 'IcrTouchScheduleConfig_Updated',
    JobRoleCreated = 'JobRole_Created',
    JobRoleDeleted = 'JobRole_Deleted',
    JobRoleUpdated = 'JobRole_Updated',
    LeaveAdjustmentCreated = 'LeaveAdjustment_Created',
    LeaveAdjustmentDeleted = 'LeaveAdjustment_Deleted',
    LeaveAdjustmentUpdated = 'LeaveAdjustment_Updated',
    LeaveAllowanceChunkCreated = 'LeaveAllowanceChunk_Created',
    LeaveAllowanceChunkDeleted = 'LeaveAllowanceChunk_Deleted',
    LeaveAllowanceChunkUpdated = 'LeaveAllowanceChunk_Updated',
    LeavePeriodCreated = 'LeavePeriod_Created',
    LeavePeriodDeleted = 'LeavePeriod_Deleted',
    LeavePeriodUpdated = 'LeavePeriod_Updated',
    LeavePoliciesLeaveTypeCreated = 'LeavePoliciesLeaveType_Created',
    LeavePoliciesLeaveTypeDeleted = 'LeavePoliciesLeaveType_Deleted',
    LeavePoliciesLeaveTypeUpdated = 'LeavePoliciesLeaveType_Updated',
    LeavePolicyCreated = 'LeavePolicy_Created',
    LeavePolicyDeleted = 'LeavePolicy_Deleted',
    LeavePolicyUpdated = 'LeavePolicy_Updated',
    LeaveRequestCreated = 'LeaveRequest_Created',
    LeaveRequestDeleted = 'LeaveRequest_Deleted',
    LeaveRequestUpdated = 'LeaveRequest_Updated',
    LeaveSettingCreated = 'LeaveSetting_Created',
    LeaveSettingDeleted = 'LeaveSetting_Deleted',
    LeaveSettingUpdated = 'LeaveSetting_Updated',
    LeaveSettingsDefaultLeaveApproverCreated = 'LeaveSettingsDefaultLeaveApprover_Created',
    LeaveSettingsDefaultLeaveApproverDeleted = 'LeaveSettingsDefaultLeaveApprover_Deleted',
    LeaveSettingsDefaultLeaveApproverUpdated = 'LeaveSettingsDefaultLeaveApprover_Updated',
    LeaveTypeCreated = 'LeaveType_Created',
    LeaveTypeDeleted = 'LeaveType_Deleted',
    LeaveTypeUpdated = 'LeaveType_Updated',
    LeaveTypeAccrualCreated = 'LeaveTypeAccrual_Created',
    LeaveTypeAccrualDeleted = 'LeaveTypeAccrual_Deleted',
    LeaveTypeAccrualUpdated = 'LeaveTypeAccrual_Updated',
    LocationCreated = 'Location_Created',
    LocationDeleted = 'Location_Deleted',
    LocationUpdated = 'Location_Updated',
    MfaDeviceCreated = 'MfaDevice_Created',
    MfaDeviceDeleted = 'MfaDevice_Deleted',
    MfaDeviceUpdated = 'MfaDevice_Updated',
    NotificationSettingCreated = 'NotificationSetting_Created',
    NotificationSettingDeleted = 'NotificationSetting_Deleted',
    NotificationSettingUpdated = 'NotificationSetting_Updated',
    OfferCreated = 'Offer_Created',
    OfferDeleted = 'Offer_Deleted',
    OfferUpdated = 'Offer_Updated',
    OffersBehaviourCreated = 'OffersBehaviour_Created',
    OffersBehaviourDeleted = 'OffersBehaviour_Deleted',
    OffersBehaviourUpdated = 'OffersBehaviour_Updated',
    OffersQuotaCreated = 'OffersQuota_Created',
    OffersQuotaDeleted = 'OffersQuota_Deleted',
    OffersQuotaUpdated = 'OffersQuota_Updated',
    OffersRedemptionCreated = 'OffersRedemption_Created',
    OffersRedemptionDeleted = 'OffersRedemption_Deleted',
    OffersRedemptionUpdated = 'OffersRedemption_Updated',
    OffersUsageCreated = 'OffersUsage_Created',
    OffersUsageDeleted = 'OffersUsage_Deleted',
    OffersUsageUpdated = 'OffersUsage_Updated',
    OpenShiftResponseCreated = 'OpenShiftResponse_Created',
    OpenShiftResponseDeleted = 'OpenShiftResponse_Deleted',
    OpenShiftResponseUpdated = 'OpenShiftResponse_Updated',
    PayCycleCreated = 'PayCycle_Created',
    PayCycleDeleted = 'PayCycle_Deleted',
    PayCycleUpdated = 'PayCycle_Updated',
    PayPeriodCreated = 'PayPeriod_Created',
    PayPeriodDeleted = 'PayPeriod_Deleted',
    PayPeriodUpdated = 'PayPeriod_Updated',
    PayRuleCreated = 'PayRule_Created',
    PayRuleDeleted = 'PayRule_Deleted',
    PayRuleUpdated = 'PayRule_Updated',
    PayTypeCreated = 'PayType_Created',
    PayTypeDeleted = 'PayType_Deleted',
    PayTypeUpdated = 'PayType_Updated',
    PendingActionCreated = 'PendingAction_Created',
    PendingActionDeleted = 'PendingAction_Deleted',
    PendingActionUpdated = 'PendingAction_Updated',
    PublicHolidayCreated = 'PublicHoliday_Created',
    PublicHolidayDeleted = 'PublicHoliday_Deleted',
    PublicHolidayUpdated = 'PublicHoliday_Updated',
    ScheduleCreated = 'Schedule_Created',
    ScheduleDeleted = 'Schedule_Deleted',
    ScheduleUpdated = 'Schedule_Updated',
    ScheduleEventCreated = 'ScheduleEvent_Created',
    ScheduleEventDeleted = 'ScheduleEvent_Deleted',
    ScheduleEventUpdated = 'ScheduleEvent_Updated',
    ScheduleEventsScheduleCreated = 'ScheduleEventsSchedule_Created',
    ScheduleEventsScheduleDeleted = 'ScheduleEventsSchedule_Deleted',
    ScheduleEventsScheduleUpdated = 'ScheduleEventsSchedule_Updated',
    ScheduleOverviewSummaryCreated = 'ScheduleOverviewSummary_Created',
    ScheduleOverviewSummaryDeleted = 'ScheduleOverviewSummary_Deleted',
    ScheduleOverviewSummaryUpdated = 'ScheduleOverviewSummary_Updated',
    ScheduleSettingCreated = 'ScheduleSetting_Created',
    ScheduleSettingDeleted = 'ScheduleSetting_Deleted',
    ScheduleSettingUpdated = 'ScheduleSetting_Updated',
    ScheduleTemplateCreated = 'ScheduleTemplate_Created',
    ScheduleTemplateDeleted = 'ScheduleTemplate_Deleted',
    ScheduleTemplateUpdated = 'ScheduleTemplate_Updated',
    ScheduledBreakCreated = 'ScheduledBreak_Created',
    ScheduledBreakDeleted = 'ScheduledBreak_Deleted',
    ScheduledBreakUpdated = 'ScheduledBreak_Updated',
    ShiftCreated = 'Shift_Created',
    ShiftDeleted = 'Shift_Deleted',
    ShiftUpdated = 'Shift_Updated',
    ShiftAreaCreated = 'ShiftArea_Created',
    ShiftAreaDeleted = 'ShiftArea_Deleted',
    ShiftAreaUpdated = 'ShiftArea_Updated',
    ShiftAreaSessionCreated = 'ShiftAreaSession_Created',
    ShiftAreaSessionDeleted = 'ShiftAreaSession_Deleted',
    ShiftAreaSessionUpdated = 'ShiftAreaSession_Updated',
    ShiftAreasLocationCreated = 'ShiftAreasLocation_Created',
    ShiftAreasLocationDeleted = 'ShiftAreasLocation_Deleted',
    ShiftAreasLocationUpdated = 'ShiftAreasLocation_Updated',
    ShiftConflictCreated = 'ShiftConflict_Created',
    ShiftConflictDeleted = 'ShiftConflict_Deleted',
    ShiftConflictUpdated = 'ShiftConflict_Updated',
    ShiftCostCreated = 'ShiftCost_Created',
    ShiftCostDeleted = 'ShiftCost_Deleted',
    ShiftCostUpdated = 'ShiftCost_Updated',
    ShiftSwapCreated = 'ShiftSwap_Created',
    ShiftSwapDeleted = 'ShiftSwap_Deleted',
    ShiftSwapUpdated = 'ShiftSwap_Updated',
    ShiftTemplateCreated = 'ShiftTemplate_Created',
    ShiftTemplateDeleted = 'ShiftTemplate_Deleted',
    ShiftTemplateUpdated = 'ShiftTemplate_Updated',
    ShiftTemplateAreaSessionCreated = 'ShiftTemplateAreaSession_Created',
    ShiftTemplateAreaSessionDeleted = 'ShiftTemplateAreaSession_Deleted',
    ShiftTemplateAreaSessionUpdated = 'ShiftTemplateAreaSession_Updated',
    ShiftTemplateBreakCreated = 'ShiftTemplateBreak_Created',
    ShiftTemplateBreakDeleted = 'ShiftTemplateBreak_Deleted',
    ShiftTemplateBreakUpdated = 'ShiftTemplateBreak_Updated',
    ShiftTemplatesTagCreated = 'ShiftTemplatesTag_Created',
    ShiftTemplatesTagDeleted = 'ShiftTemplatesTag_Deleted',
    ShiftTemplatesTagUpdated = 'ShiftTemplatesTag_Updated',
    ShiftsTagCreated = 'ShiftsTag_Created',
    ShiftsTagDeleted = 'ShiftsTag_Deleted',
    ShiftsTagUpdated = 'ShiftsTag_Updated',
    TagCreated = 'Tag_Created',
    TagDeleted = 'Tag_Deleted',
    TagUpdated = 'Tag_Updated',
    TimesheetBreakCreated = 'TimesheetBreak_Created',
    TimesheetBreakDeleted = 'TimesheetBreak_Deleted',
    TimesheetBreakUpdated = 'TimesheetBreak_Updated',
    TimesheetEntriesTagCreated = 'TimesheetEntriesTag_Created',
    TimesheetEntriesTagDeleted = 'TimesheetEntriesTag_Deleted',
    TimesheetEntriesTagUpdated = 'TimesheetEntriesTag_Updated',
    TimesheetEntryCreated = 'TimesheetEntry_Created',
    TimesheetEntryDeleted = 'TimesheetEntry_Deleted',
    TimesheetEntryUpdated = 'TimesheetEntry_Updated',
    TimesheetEntryConflictCreated = 'TimesheetEntryConflict_Created',
    TimesheetEntryConflictDeleted = 'TimesheetEntryConflict_Deleted',
    TimesheetEntryConflictUpdated = 'TimesheetEntryConflict_Updated',
    TimesheetEntryCostCreated = 'TimesheetEntryCost_Created',
    TimesheetEntryCostDeleted = 'TimesheetEntryCost_Deleted',
    TimesheetEntryCostUpdated = 'TimesheetEntryCost_Updated',
    TimesheetEntryExportCreated = 'TimesheetEntryExport_Created',
    TimesheetEntryExportDeleted = 'TimesheetEntryExport_Deleted',
    TimesheetEntryExportUpdated = 'TimesheetEntryExport_Updated',
    TimesheetEntrySummaryCreated = 'TimesheetEntrySummary_Created',
    TimesheetEntrySummaryDeleted = 'TimesheetEntrySummary_Deleted',
    TimesheetEntrySummaryUpdated = 'TimesheetEntrySummary_Updated',
    TimesheetSettingCreated = 'TimesheetSetting_Created',
    TimesheetSettingDeleted = 'TimesheetSetting_Deleted',
    TimesheetSettingUpdated = 'TimesheetSetting_Updated',
    TrekksoftClientCredentialCreated = 'TrekksoftClientCredential_Created',
    TrekksoftClientCredentialDeleted = 'TrekksoftClientCredential_Deleted',
    TrekksoftClientCredentialUpdated = 'TrekksoftClientCredential_Updated',
    UnavailabilityCreated = 'Unavailability_Created',
    UnavailabilityDeleted = 'Unavailability_Deleted',
    UnavailabilityUpdated = 'Unavailability_Updated',
    UploadCreated = 'Upload_Created',
    UploadDeleted = 'Upload_Deleted',
    UploadUpdated = 'Upload_Updated',
    UserCreated = 'User_Created',
    UserDeleted = 'User_Deleted',
    UserUpdated = 'User_Updated',
    WorkPatternCreated = 'WorkPattern_Created',
    WorkPatternDeleted = 'WorkPattern_Deleted',
    WorkPatternUpdated = 'WorkPattern_Updated',
    WorkPatternOverrideCreated = 'WorkPatternOverride_Created',
    WorkPatternOverrideDeleted = 'WorkPatternOverride_Deleted',
    WorkPatternOverrideUpdated = 'WorkPatternOverride_Updated'
}


/**
 * Check if a given object implements the ListEventNamesResponse interface.
 */
export function instanceOfListEventNamesResponse(value: object): value is ListEventNamesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEventNamesResponseFromJSON(json: any): ListEventNamesResponse {
    return ListEventNamesResponseFromJSONTyped(json, false);
}

export function ListEventNamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEventNamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEventNamesResponseToJSON(json: any): ListEventNamesResponse {
      return ListEventNamesResponseToJSONTyped(json, false);
  }

  export function ListEventNamesResponseToJSONTyped(value?: ListEventNamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'pagination': PaginationToJSON(value['pagination']),
    };
}

